/** Public links use the configured application origins or the current local server. */
export const ATLAS_APP_ORIGIN = 'https://atlas.solidum-invest.de';

export function isAtlasAppOrigin(url: URL): boolean {
  if (url.username || url.password) return false;
  const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
  return local
    ? ['https:', 'http:'].includes(url.protocol)
    : url.protocol === 'https:' &&
        ['atlas.solidum-invest.de', 'atlas-staging.solidum-invest.de'].includes(
          url.host
        );
}

export function currentAppOrigin(): string {
  if (typeof window === 'undefined') return ATLAS_APP_ORIGIN;
  try {
    const current = new URL(window.location.href);
    return isAtlasAppOrigin(current) ? current.origin : ATLAS_APP_ORIGIN;
  } catch {
    return ATLAS_APP_ORIGIN;
  }
}
